var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3281 4.17188L1.46875 15.0312L1 19.4844C0.921875 20.0703 1.42969 20.5781 2.01562 20.5L6.46875 20.0312L17.3281 9.17188L12.3281 4.17188ZM20.4141 3.42969L18.0703 1.08594C17.3672 0.34375 16.1562 0.34375 15.4141 1.08594L13.2266 3.27344L18.2266 8.27344L20.4141 6.08594C21.1562 5.34375 21.1562 4.13281 20.4141 3.42969Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.061dae84bc4ac95bb1a4a64537c729fd.svg";
export { ForwardRef as ReactComponent };